import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react';
import { useRef, type ReactNode } from 'react';

export type ModalProps = {
  show: boolean;
  onClose?: () => void;
  /** When false, backdrop click and Escape do not close the dialog. */
  closeOnBackdrop?: boolean;
  title?: ReactNode;
  titleClassName?: string;
  bottom?: ReactNode;
  children?: ReactNode;
};

export default function Modal({
  show,
  onClose = () => {},
  closeOnBackdrop = true,
  title = '',
  titleClassName,
  bottom = null,
  children,
}: ModalProps) {
  const cancelButtonRef = useRef<HTMLElement | null>(null);

  return (
    <Dialog
      open={show}
      onClose={closeOnBackdrop ? onClose : () => {}}
      className="relative z-50"
      initialFocus={cancelButtonRef}
    >
      <DialogBackdrop className="fixed inset-0 bg-bk-bg/80 backdrop-blur-sm" />
      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center">
          <DialogPanel className="relative my-8 w-full max-w-lg transform overflow-hidden border border-bk-gold-dim/60 bg-bk-panel px-6 py-6 text-left text-bk-text shadow-[0_0_40px_rgba(0,0,0,0.65),inset_0_1px_0_color-mix(in_srgb,var(--color-bk-gold)_20%,transparent)]">
            <div className="space-y-4 text-center">
              {title ? (
                <DialogTitle
                  as="h3"
                  className={
                    titleClassName ??
                    'text-xl font-bold uppercase tracking-wider text-bk-gold md:text-2xl lg:text-3xl'
                  }
                >
                  {title}
                </DialogTitle>
              ) : null}
              <div className="mt-2 space-y-4 text-xs text-bk-text sm:text-sm md:text-base lg:text-lg">
                {children}
              </div>
            </div>
            {bottom}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
